import { Component, OnInit, ViewChild } from '@angular/core';
import {Module, AllCommunityModules } from '@ag-grid-community/all-modules';
import { EditButtonRendererComponent } from '../../renderer/edit-button-renderer.component';
import { DeleteButtonRendererComponent } from '../../renderer/delete-button-renderer.component';
import * as _ from 'lodash';
import { ModalDirective } from 'ngx-bootstrap/modal';
import * as moment from 'moment';
import { ConstantService } from '../../services/constant.service';
import { ApiService } from '../../services/api.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { HttpClient } from '@angular/common/http';
import { ImageRendererComponent } from '../../renderer/image-renderer.component';
import { ExportAsService } from 'ngx-export-as';
import { ExcelService } from '../../services/export-excel.service';

@Component({
  selector: 'app-leave-request',
  templateUrl: './leave-request.component.html'
})
export class LeaveRequestComponent implements OnInit {
  @ViewChild('addDataModal') public addDataModal: ModalDirective;
  @ViewChild('deleteDataModal') public deleteDataModal: ModalDirective;
  @ViewChild('updateDataModal') public updateDataModal: ModalDirective;
  @ViewChild('deleteBulkComplainModal') public deleteBulkComplainModal: ModalDirective;
  @ViewChild('attachmentModal') public attachmentModal: ModalDirective;
  public gridApi;
  public gridColumnApi;
  public modules: Module[] = AllCommunityModules;
  public context;
  public frameworkComponents;
  public defaultColDef;
  public columnDefs;
  private permission;
  public selectedColony = [];
  public states;

  public rowSelection;
  _ = _;
  public userTypeList: any = [
    {typeCode: 'admin', permission: 'rwmd'},
    {typeCode: 'staff', permission: 'r'}
  ];
  maxDate = new Date();
  statusList: any = [];
  expenseHeadList: any = [];
  dataList = [];
  departments = [];
  newForm = {
    date: "2022-01-06",
    project: "",
    username: "",
    employee_id: "",
    fullName: "",
    location: "",
    date_from: "",
    date_to: "",
    reason: "",
    remarks: "",
    status: ""
  }
  disabledEle = ['project', 'username', 'date_from', 'date_to', 'reason', 'date', 'fullName'];

  alert = {
    type: 'info',
    msg: '',
    timeout: 5000
  }
  dropdownList = [];
  selectedItems = [];
  employeeListDropdown: any = [];
  dropdownSettings: IDropdownSettings = {};
  userList: any = [];
  filterParams: any = {dateRange: [moment().format(), moment().add(30, 'days').format()]};
  constructor(private constantService:  ConstantService, private apiService: ApiService, private http: HttpClient,
    private exportAsService: ExportAsService, private excelService: ExcelService) {

    this.permission = this.constantService.getCookies().PERMISSION;
    let permissionArray = this.permission.split('')
    this.context = { componentParent: this };
    this.defaultColDef = {
      sortable: true,
      filter: true,
      flex:0,
      resizable: true,
      floatingFilter: true,
    };
    this.frameworkComponents = {
      editButtonRenderer: EditButtonRendererComponent,
      deleteButtonRenderer : DeleteButtonRendererComponent,
      imageButtonRenderer : ImageRendererComponent,
    };
    this.states = this.constantService.getDataConstant('states');
    console.log(this.states);

    this.rowSelection = 'multiple';

    this.columnDefs = [
      { headerName: 'Srl No', field: 'srl_no', flex: 1, filter: false,}
    ];
    _.each(_.keys(this.newForm), (field) => {
      this.columnDefs.push({ headerName: this.convertLabel(field), field: field, flex:1 })
    })
      // this.columnDefs.push(
      //   { headerName: 'Attachment', field: 'value', cellRenderer: 'imageButtonRenderer', colId: 'paramsImg',  width: 60, filter: false, resizable: true, sortable: false,cellClass: ['text-center'], pinned: 'right'  },
      //   );

    if (_.includes(permissionArray, 'd')) {
      this.columnDefs.push({ headerName: 'Edit', field: 'value', cellRenderer: 'editButtonRenderer', colId: 'params',  width: 60, filter: false, resizable: true, sortable: false,cellClass: ['text-center'], pinned: 'right'  },
      // { headerName: 'Delete', field: 'value', cellRenderer: 'deleteButtonRenderer', colId: 'params1',  width: 60, filter: false, resizable: true, sortable: false,cellClass: ['text-center'], pinned: 'right'  },
      )
    }
   }

   headList: any = [];
  ngOnInit(): void {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    // this.departments = this.profileService.getDepartment();
    // console.log(this.departments);
    this.listData();
    this.listProject();
    this.listUser();
    this.statusList =  [{item_id:'Yes', item_text: 'Yes'}, {item_id:'No', item_text: 'No'}];
    let document_list: any = [];
    this.headList = this.constantService.getDataConstant('expense_head');
    this.expenseHeadList = this.arrangeMultiselectData(this.headList, '', '');
  }
  listData() {
    let queryString = " leave_manager.* , project.name as project FROM leave_manager, project WHERE leave_manager.project = project.srl_no ORDER BY leave_manager.srl_no DESC";
    this.apiService.getCustomData(btoa(queryString)).subscribe((resp: []) => {
      this.paginatedRecord = resp;
    })
  }
  projectList: any = [];
  listProject() {
    this.apiService.getData('project').then((resp: []) => {
      this.projectList = resp;
    })
  }


  userObject: any = {}
  listUser() {
    this.apiService.getData('employees').then((resp: []) => {
      this.userList = resp;
      _.each(this.userList, (u) => {
        this.userObject[u.phone_no]=u;
      })
      this.employeeListDropdown = this.arrangeMultiselectData(resp, 'phone_no', 'full_name');
      this.searchReport();
    })
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridColumnApi.moveColumn('full_name', 4);
  }
  selectedData: any = {};
  methodFromParent(userData) {
    this.selectedData = userData;
    console.log(this.selectedData, userData.action);
    if(userData.action === 'edit') {
      this.newForm = _.clone(this.selectedData);
      delete this.newForm['srl_no'];
      delete this.newForm['action'];
      delete this.newForm['timestamp'];
      delete this.newForm['full_name'];

      this.updateDataModal.show();
    }
    if(userData.action === 'delete') {
      this.deleteDataModal.show();
    }
    if(userData.action === 'image') {
      this.attachmentModal.show();
    }


  }

  savenewForm() {

    let duplicateRecord = this.checkForDuplicates(this.newForm);
    if(duplicateRecord) {
      this.alert.type = 'danger';
      this.alert.msg = 'Data already saved';
      setTimeout(() => {
        this.addDataModal.hide();
      this.alert.type = '';
        this.alert.msg = '';
      }, 2000)
    } else {

      this.apiService.addData('expense', this.newForm).subscribe((resp) => {
        console.log(resp);
        this.resetForm();
        this.listData();
        this.alert.msg = 'Data has been successfully created.';
        setTimeout(() => {
          this.addDataModal.hide();
          this.alert.msg = '';
        }, 2000)
      })

    }


  }

  selectUserType(type) {
    if(type !== 'department') {
    }
  }
  resetForm() {
    this.newForm = {
      date: "2022-01-06",
      project: "",
      employee_id: "",
      username: "",
      fullName: "",
      location: "",
      date_from: "",
      date_to: "",
      reason: "",
      remarks: "",
      status: ""
    }
  }

  updateProfile() {
    let that = this;
    let payload = {
      status: this.newForm.status,
      remarks: this.newForm.remarks
    }
    this.apiService.updateDetail('leave_manager', 'srl_no', this.selectedData.srl_no, payload).subscribe((resp) => {
      console.log(resp);
      that.resetForm();
      that.listData();
      that.alert.msg = 'Data has been successfully updated.';
      setTimeout(() => {
        that.updateDataModal.hide();
        that.alert.msg = '';
      }, 1000)
    })
  }

  bulkUpload() {

  }
  onItemSelect(e) {
  }
  onItemDeSelect(e) {
  }
  onSelectAll(items: any) {
    console.log(items);
  }

  checkForDuplicates(data) {
    let filterData = _.filter(this.dataList, (item) => {
      return (item.phone_no).trim() === (data.phone_no).trim();
    })
    console.log(filterData);
    if (filterData.length > 0) {
      return filterData[0];
    } else {
      return null;
    }

  }

  convertLabel(label: string) {
    return label.replace(/_/g, ' ').toUpperCase();
  }


  formData  = new FormData();
  fileChange(index,event) {
    const file = event.target.files[0];
    const reader = new FileReader();
    let that = this;
    reader.readAsDataURL(file);
    reader.onload = () => {
        // that.newForm.attachment = reader.result as string;
    };
  }
  arrangeMultiselectData(data, p1, p2) {
      let list: any = [];
      _.each(data, (item) => {
        list.push({ item_id: p1 ? item[p1] : item, item_text: p2 ? item[p2] : item})
      })
      console.log(list);
      let l = list
      return l;
  }

  records = [];
  paginatedRecord = [];
  paginaton = {
    totalItems: 0,
    currentPage: 1,
    maxSize: 100,
  }
  selectedUsername: any = [];
  selectedStatus: any = [];
  selectedHead: any = []
  searchReport() {
    this.records = [];
    this.paginatedRecord = [];
    this.filterParams.username = ((this.selectedUsername).map(item => "'" + item.item_id + "'")).join(',');
    this.filterParams.status = (((this.selectedStatus).map(item => "'" + item.item_id + "'")).join(','));
    this.filterParams.head = (((this.selectedHead).map(item => "'" + item.item_id + "'")).join(','));
    let queryString = "leave_manager.* FROM leave_manager  WHERE leave_manager.date BETWEEN '" + moment(this.filterParams.dateRange[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss') + "' AND '" + moment(this.filterParams.dateRange[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss') + "'";
    if(this.filterParams.username) queryString += " AND leave_manager.username IN (" + this.filterParams.username + ")";
    // queryString += " AND leave_manager.project = project.srl_no";
    queryString += " ORDER BY leave_manager.srl_no DESC";
    console.log(queryString);
    this.apiService.getCustomData(btoa(queryString)).subscribe((resp: any) => {
      this.records = resp;
      _.each(this.records, (r)=> {
        r['location']=this.userObject[r.username].work_location;
        r['fullName']=this.userObject[r.username].full_name;
        r['employee_id']=this.userObject[r.username].employee_id;
      })
      console.log(this.records);
      this.paginaton.totalItems = this.records.length;
      this.arrangeDataForExport(this.records);
      this.pageChanged({ page: 1, itemsPerPage: 100 });
    })
  }

  pageChanged(event): void {
    this.paginaton.currentPage = event.page;
    this.paginatedRecord = this.records.slice((this.paginaton.currentPage - 1) * this.paginaton.maxSize, this.paginaton.currentPage * this.paginaton.maxSize);

    // this.arrangeDataForExport(this.paginatedRecord);
  }
  excelExportData: any = [];

  ClickExport(): void {
    let complainDate = "";
      complainDate = `Leave Request between [ ${moment(this.filterParams.dateRange[0]).format('YYYY-MM-DD')} - ${moment(this.filterParams.dateRange[1]).format('YYYY-MM-DD')}]`;
    let fileData = {
      fileName: `Leave_Request_between_${moment(this.filterParams.dateRange[0]).format('YYYY-MM-DD')}_${moment(this.filterParams.dateRange[1]).format('YYYY-MM-DD')}`,
      reportDate: moment().format('YYYY-MM-DD'),
      dateFilter: complainDate,
    }

    let header = [ 'Date','Project Name','Employee Id','Phone No', 'Full Name', 'Date From', 'Date To', 'Reason', 'Remarks', 'Status'];
    this.excelService.generateExcel(this.excelExportData, fileData, header);
  }

  arrangeDataForExport(records) {
    let data: any = [];
    _.each(records, (r)=> {
      data.push([r.date,r.project,r.employee_id, r.username, r.fullName,  r.date_from, r.date_to, r.reason, r.remarks, r.status]);
    })
    this.excelExportData = data;
    console.log(this.excelExportData)
  }
}
